// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/AdminRegistration/index.css
// module id = 3123
// module chunks = 0